import app from './Vue/app';
import WaterBottom from './Vue/Components/WaterBottom.vue';
import BlogPagination from './Vue/Components/blog/BlogPagination.vue';
import Stickers from './Vue/Components/blog/Stickers.vue';
import BlogAnim from './Vue/Components/blog/BlogAnim.vue';

app.component('WaterBottom', WaterBottom);
app.component('BlogPagination', BlogPagination);
app.component('Stickers', Stickers);
app.component('BlogAnim', BlogAnim);
